export default "/fonts/vendor/katex/dist/KaTeX_Size3-Regular.woff2?e1951519f6f0596f735635e962d5b82c";